import { Container, Col, Row } from "reactstrap";
import { BreadcrumbItem } from "reactstrap";
import { Component as Form } from "@repoflow/form-schema";
import * as Notify from "@repoflow/form-schema/notify";
import {
  Mutation,
  Button,
  useSectionContext,
} from "@repoflow/components/section";
import { CancellableContent } from "@repoflow/components/content-cancel";
import * as QueriesQL from "queries/domain";

export const Sidebar = () => null;

export const Indice = () => <BreadcrumbItem>Create</BreadcrumbItem>;

export const Content = ({
  history,
  match: { params },
}) => {

  const { base } = useSectionContext();
  const initial = {
    description: "",
    domain: "",
    publicKey: "",
    privateKey: "",
    webhookRoute: ""
  };

  return (
    <Mutation
      initial={initial}
      target={{ $ref: "/Public/Domain/Create" }}
      mutation={QueriesQL.create}
      update={QueriesQL.update(params)}
      onMutate={({ handler, state: { values: input } }) => {
        handler({ variables: { input } });
      }}
      onCompleted={() => {
        history.replace(base);
      }}
      onError={(error) => {
        Notify.error(error.toString());
      }}
    >
      {MutationHandler}
    </Mutation>
  );
};

const MutationHandler = ({ target, state, schema, mutate }) => {
  const { values, setValues } = state;

  const formProps = {
    schema,
    target,
    onSubmit: () => {
      mutate();
    },
    onChange: (values) => {
      setValues(values);
    },
    config: {
      "/Public/Domain/Create": {
        fields: [
          "domain",
          "description",
          "publicKey",
          "privateKey",
          "webhookRoute"
        ],
      },
    },
    values,
  };

  return (
    <CancellableContent>
      <Container className="mt-4">
        <Row>
          <Col>
            <Form {...formProps}>
              <Button type="submit">Create</Button>
            </Form>
          </Col>
        </Row>
      </Container>
    </CancellableContent>
  );
};
